export default __webpack_public_path__ + "static/media/star_three_quarter.20a9d519.svg";